import GridTile from "../../grid/GridTile";
import ScoreTile from "./ScoreTile";

export default class PriorityQueue2 {
    constructor() {

        const initialCapacity = 100;

        /**
         * @constant
         * @type {Array.<ScoreTile>}
         */   
        this.queue = new Array(initialCapacity);
        for (let i = 0; i < initialCapacity; i++) {
            this.queue[i] = new ScoreTile();
        }

        this.size = 0;
    }

    // add() just calls offer
    // public boolean offer(E e) {
    //     if (e == null)
    //         throw new NullPointerException();
    //     modCount++;
    //     int i = size;
    //     if (i >= queue.length)
    //         grow(i + 1);
    //     siftUp(i, e);
    //     size = i + 1;
    //     return true;
    // }

    /**
     * @param {number} score
     * @param {GridTile} tile 
     */
    add(score, tile) {
        if (this.size >= this.queue.length) {
            this.grow(this.size + 1);
        }

        this.siftUpUsingComparator(this.size, score, tile);
        this.size = this.size + 1;
    }



    // private void grow(int minCapacity) {
    //     int oldCapacity = queue.length;
    //     // Double size if small; else grow by 50%
    //     int newCapacity = ArraysSupport.newLength(oldCapacity,
    //             minCapacity - oldCapacity, /* minimum growth */
    //             oldCapacity < 64 ? oldCapacity + 2 : oldCapacity >> 1
    //                                        /* preferred growth */);
    //     queue = Arrays.copyOf(queue, newCapacity);
    // }    

    /**
     * @private
     * @param {number} minCapacity 
     */
    grow(minCapacity) {
        const oldCapacity = this.queue.length;

        // Double size if small; else grow by 50%
        // let newCapacity = ArraysSupport.newLength(oldCapacity,
        //         minCapacity - oldCapacity, /* minimum growth */
        //         oldCapacity < 64 ? oldCapacity + 2 : oldCapacity >> 1 /* preferred growth */);

        const minGrowth = minCapacity - oldCapacity;
        const prefGrowth = oldCapacity < 64 ? oldCapacity + 2 : oldCapacity >> 1;
        const growAmount = Math.max(minGrowth, prefGrowth);

        console.log('PriorityQueue2.grow() length=' + this.queue.length + ' min=' + minGrowth + ' pref=' + prefGrowth + ' amount=' + growAmount);

        for (let i = 0; i < growAmount; i++) {
            this.queue.push(new ScoreTile());
        }

        console.log('PriorityQueue2.grow() new length: ' + this.queue.length);
    }

    // private static <T> void siftUpUsingComparator(
    //     int k, T x, Object[] es, Comparator<? super T> cmp) {
    //     while (k > 0) {
    //         int parent = (k - 1) >>> 1;
    //         Object e = es[parent];
    //         if (cmp.compare(x, (T) e) >= 0)
    //             break;
    //         es[k] = e;
    //         k = parent;
    //     }
    //     es[k] = x;
    // }

    /**
     * @private
     * @param {number} index 
     * @param {number} score 
     * @param {GridTile} tile 
     */
    siftUpUsingComparator(index, score, tile) {

        while (index > 0) {
            const parentIndex = (index - 1) >>> 1;

            let parentScoreTile = this.queue[parentIndex];
            if (this.compare(score, parentScoreTile.score) >= 0) {
                break;
            }
            this.queue[index].copy(parentScoreTile);
            index = parentIndex;
        }

        this.queue[index].set(score, tile);
    }

    // private static <T> void siftDownUsingComparator(
    //     int k, T x, Object[] es, int n, Comparator<? super T> cmp) {
    //     // assert n > 0;
    //     int half = n >>> 1;
    //     while (k < half) {
    //         int child = (k << 1) + 1;
    //         Object c = es[child];
    //         int right = child + 1;
    //         if (right < n && cmp.compare((T) c, (T) es[right]) > 0)
    //             c = es[child = right];
    //         if (cmp.compare(x, (T) c) <= 0)
    //             break;
    //         es[k] = c;
    //         k = child;
    //     }
    //     es[k] = x;
    // }

    /**
     * @private
     * @param {number} index 
     * @param {number} score
     * @param {GridTile} tile
     */
    siftDownUsingComparator(index, score, tile) {
        // assert n > 0;
        let half = this.size >>> 1;

        while (index < half) {
            let childIndex = (index << 1) + 1;
            let childScoreTile = this.queue[childIndex];
            let rightIndex = childIndex + 1;
            if (rightIndex < this.size && this.compare(childScoreTile.score, this.queue[rightIndex].score) > 0) {
                childIndex = rightIndex;
                childScoreTile = this.queue[childIndex];
            }
            if (this.compare(score, childScoreTile.score) <= 0) {
                break;
            }
            this.queue[index].copy(childScoreTile);
            index = childIndex;
        }

        this.queue[index].set(score, tile);
    }


    // public E poll() {
    //     final Object[] es;
    //     final E result;

    //     if ((result = (E) ((es = queue)[0])) != null) {
    //         modCount++;
    //         final int n;
    //         final E x = (E) es[(n = --size)];
    //         es[n] = null;
    //         if (n > 0) {
    //             final Comparator<? super E> cmp;
    //             if ((cmp = comparator) == null)
    //                 siftDownComparable(0, x, es, n);
    //             else
    //                 siftDownUsingComparator(0, x, es, n, cmp);
    //         }
    //     }
    //     return result;
    // }


    /**
     * @returns {GridTile}
     */
    poll() {
        let firstElement = this.queue[0];
        const tile = firstElement.tile;

        this.size--;

        const scoreTile = this.queue[this.size];

        const tileToSift = scoreTile.tile;
        const scoreToSift = scoreTile.score;
        scoreTile.reset();

        if (this.size > 0) {
            this.siftDownUsingComparator(0, scoreToSift, tileToSift);
        }

        return tile;
    }

    /**
     * @private
     * @param {number} x
     * @param {number} y
     * @returns {number}
     */
    compare(x, y) {
        return x - y;
        //////return (x < y) ? -1 : ((x == y) ? 0 : 1);
    }

    /**
     * @returns {boolean}
     */
    isEmpty() {
        return this.size === 0;
    }
    
    clear() {
        for (let i = 0; i < this.size; i++) {
            this.queue[i].reset();
        }
        this.size = 0;
    }
}